import { separateHourFromDateAndFormatToString } from "widgets/widgetsUtils"
import { ArticleCommentRenderProps } from "../../article/componentas/articleComments/articleCommentWrapper"
import { getTranslation } from "../../article/componentas/articleComments/translations";

export interface ArticleCommentGalhedUiProps {
    props: ArticleCommentRenderProps
    isNewDesign?: boolean
}

export class ArticleCommentGalhedUi extends React.Component<ArticleCommentGalhedUiProps, {}> {
    render() {
        const { isNewDesign } = this.props
        const { lang,
            comment: {
                text,
                author,
                pubDate,
            } } = this.props.props


        const articlePublishDate = separateHourFromDateAndFormatToString(pubDate, { showHour: false })
        const authorName = author !== "" ? author : getTranslation(lang, "Anonymous")

        if (isNewDesign) {
            return (
                <div id="articleComments" className="ArticleComment ArticleCommentRedesign">
                    <div className="commentCardHeader">
                        <span className="publishDate">{articlePublishDate}</span>
                        <span className="quoteIcon" aria-hidden="true" />
                    </div>
                    <div className="commentText">{text}</div>
                    <div className="authorName">{authorName}</div>
                </div>
            )
        }

        return (
            <div id="articleComments" className="ArticleComment">
                <div className="topView" >
                    <span>{authorName}</span>
                </div>
                <div className="commentText">{text}</div>
                <span className="publishDate">{articlePublishDate}</span>
            </div>)
    }
}
